import {stateData, reduxState} from '../../values';

const initialState = {
    users:          [],
    status:         stateData.state1,
    usersEdit:      [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_users){
        return {
            ...state,
            users:      action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_users){
        return {
            ...state,
            usersEdit: action.payload
        }
    }
    return state
}
export default reducer
